import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppContext } from "../Context/AppContext";
import { refBody } from "../Layout";
import { useMain } from "./Main";

export const useAuth = () => {
    const { Request, setForm, } = useMain();
    const [loading, setloading] = useState(false);
    const [page, setpage] = useState('auth');
    const { login } = useAppContext();
    const onChange = ({ target }) => {
        setForm(target.name, target.value)
    }

    const send = () => {
        setloading(true)
        Request({
            url: "/" + page, callback: (res) => {
                setloading(false)
                if (res) {
                    if (page == 'auth') {
                        setpage('verify')
                    } else {

                        login(res);
                    }
                }

            }
        })
    }
    return { send, onChange, loading, setpage, page }
}

export const useDrawer = (right, change) => {
    const { setData } = useMain();
    const { user, logout } = useAppContext();
    const ref = useRef(null);
    const Clickout = (eve) => {
        if (ref.current && !ref.current.contains(eve.target)) {
            change('-101%')
        }
    };
    const navigate = useNavigate()
    const styleLayer = {
        height: '1000%',
        backgroundColor: "#00000088",
        position: "fixed",
        zIndex: 1001,
        right: right,
        top: 0
    };

    const divMain = window.document.getElementById("PageMain");
    if (divMain) {
        if (right === '-101%') {
            divMain.style.overflowY = "auto"
        } else {
            divMain.style.overflowY = "hidden"
        }
    }

    const styleContent = {
        width: '80%',
        height: '1000%',
        backgroundColor: "#fff",
        position: "absolute",
        zIndex: 11000,
        right: right,
        top: 0,
        overflowY: "auto"
    };
    const clearFliter = () => {
        setData('category', null, null, true);
        setData('filter', null, 'data', true);
        navigate('/ProductList')
    }
    return {
        ref,
        user,
        logout,
        Clickout,
        navigate,
        styleLayer,
        clearFliter,
        styleContent
    }
}

export const useHome = () => {
    const { data, setData, loading, Request } = useMain();
    const { categoreis, items } = data;
    const [scrolled, setScrolled] = useState(false);
    const { items: loadItems, categoreis: loadCategory } = loading;

    useEffect(() => {
        const div = refBody.current;
        div.addEventListener("scroll", (e) => {
            if (e.target.scrollTop > 30) {
                setScrolled(true)
            } else {
                setScrolled(false)
            }
        });
    }, [])


    return { items, loadItems, loadCategory, setData, categoreis, scrolled }
}

export const useCategory = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { data, setData } = useMain();
    const [category, setCategory] = useState()
    useEffect(() => {
        if (location) {
            if (location.state) {
                if (location.state.category) {
                    setCategory(location.state.category);
                    setData('category', location.state.category, null, true)
                }
            }
        }

    }, [])
    const { categoreis, filter } = data;
    return { category, navigate, categoreis, setData, filter, setCategory }
}


export const useProductList = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { user } = useAppContext();
    const { data, Request, loading, setData, state } = useMain();
    const { products, filter, saved } = data;
    const [modal, setModal] = useState(false)
    let { category } = state;

    useEffect(() => {
        if (!category) {
            category = {
                id: "",
                title: "همه گروه بندی ها"
            }
        }

        if (location) {
            if (location.state) {
                category = location.state.category
                if (!category) {
                    category = {
                        id: "",
                        title: "همه گروه بندی ها"
                    }
                }
                setData('category', category, null, true)
            }
        }
        if (category) {
            setData('category', category, null, true)
        }
        get({ category_id: category ? category.id : null })
    }, [])

    const get = (data) => {
        setData('filter', { ...filter, ...data }, 'data', true)
        Request({ key: "products", url: "/product-list", props: { ...filter, ...data } })
    }

    const SaveFilter = () => {
        let newFilter = {
            filter: {
                name: category.title,
                ...filter
            }
        };
        setData('saved', [...saved, newFilter], 'data', true);
        if (user) {
            Request({
                url: "/add-save", props: {
                    filter: JSON.stringify({
                        name: category.title,
                        ...filter
                    })
                }
            });
        }
    }

    return { category, SaveFilter, navigate, products, get, setModal, modal, loading }
}

export const useFilter = () => {
    const { data, state, setData } = useMain();
    const { filter, categoreis } = data;
    const { category } = state;
    const [page, setpage] = useState();
    const onChange = ({ target }) => {
        setData('filter', { ...filter, [target.name]: target.value }, 'data', true)
    }

    return { filter, categoreis, category, onChange, setpage, page, setData };

}

export const useAddItem = () => {


    const { form, setForm, clearForm, Request, setFormObj, loading } = useMain();
    const [preview, setPreview] = useState([])
    const [page, setPage] = useState()
    const [category, setCategory] = useState()
    const [meta, setMeta] = useState([])
    const navigate = useNavigate();
    const { state } = useLocation();
    const { loadaddItem } = loading;
    useEffect(() => {
        clearForm();

        if (state) {
            if (state && state.item) {
                const { item } = state;

                let obj = {
                    id: item.id,
                    title: item.name,
                    description: item.meta_data && item.meta_data.description,
                    old_images: item.images,
                    type: item.type,
                    category_id: item.category_id,

                };
                setCategory(item.category)
                if (item.images) {
                    let newP = [...preview];
                    item.images.map((url, i) => {
                        newP.push({ src: url });
                    });
                    setPreview(newP)
                }

                if (item.options) {
                    let newM = [...meta];
                    item.options.map((option, i) => {
                        newM['meta_data[' + option.option.id + ']'] = option.value;
                        obj['meta_data[' + option.option.id + ']'] = option.value;
                    });
                    setMeta(newM)
                }

                setFormObj(obj)
            }
        }

    }, [])
    const fileToDataUri = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            resolve(event.target.result)
        };
        reader.readAsDataURL(file);
    })

    const onChangeImage = ({ target }) => {
        let images = null;
        if (target.files) {
            images = [target.files[0]];
            fileToDataUri(target.files[0])
                .then(dataUri => {
                    let newP = preview ? [...preview] : [];
                    newP.push({ src: dataUri, id: target.files[0].name });
                    setPreview(newP);
                    target.value = null;
                })
        }

        if (form) {
            if (form.images) {
                images = [...form.images, ...images]
            }
        }
        setForm('images', images);

    }

    const selectCategory = (prop) => {

        setCategory(prop);
        setPage(null);
        setForm('category_id', prop.id);
    }


    const add = () => {
        Request({
            url: '/add-item', loading: "loadaddItem", callback: ((res) => {
                if (res) {
                    navigate('/UserProfile')
                }
            })
        });
    }

    const removeImage = (name) => {
        if (form.images) {
            let newImages = [...form.images].filter((image) => image.name != name);
            setForm('images', newImages);
            let newP = [...preview].filter((prv) => prv.id != name);
            setPreview(newP);
        }
        if (form.old_images) {
            let newImages = [...form.old_images].filter((url) => url != name);
            setForm('old_images', newImages);
            let newP = [...preview].filter((prv) => prv.src != name);
            setPreview(newP);
        }

    }


    return { form, setForm, loadaddItem, meta, preview, setPreview, onChangeImage, clearForm, page, setPage, selectCategory, category, add, navigate, removeImage }
}

export const useProduct = () => {

    const { user } = useAppContext();
    const { setData, Request, data, loading } = useMain();
    const navigate = useNavigate();
    const { state } = useLocation();
    const [item, setitem] = useState()
    const [tooltipe, setTooltipe] = useState(false)
    const [headerBackground, setBackground] = useState("#ffffff42")
    const { favorites, rels } = data;
    const { rels: relsLoad } = loading;
    const [show, setShow] = useState(false)
    const [Loading, setLoading] = useState(false)
    const Showdes = () => {
        setShow(!show)
    }
    const [star, setStar] = useState(false);
    const { id } = useParams();
    useEffect(() => {
        loadPage()
        if (state && state.item) {
            Request({
                url: "/relation-items", props: {
                    category: state.item.category_id,
                    id: id
                }, key: "rels"
            })
        }

    }, [id]);

    useEffect(() => {
        if (id) {
            Request({
                url: "/visit", props: {
                    id: id
                }, callback: () => { }
            })
        }
        loadPage()
    }, []);


    const loadPage = () => {
        if (refBody) {
            refBody.current.scrollTop = 0;
            refBody.current.addEventListener('scroll', ({ target }) => {
                if (target.scrollTop > 150) {
                    setBackground("#ffffff")
                } else {
                    setBackground("#ffffff42")
                }
            })
        }
        if (state) {
            if (state && state.item) {
                setitem(state.item);
                if (favorites) {
                    let hasFav = favorites.filter((fav) => {

                        if (fav) {
                            if (fav.item) {
                                if (fav.item.id == state.item.id) {
                                    return fav
                                }
                                if (fav.item.id == id) {
                                    return fav
                                }
                            }
                            if (fav.name) {
                                if (fav.id == id) {
                                    return fav
                                }
                            }
                        }
                    }) || []
                    if (hasFav.length) {
                        setStar(true);
                    } else {
                        setStar(false);
                    }
                }

            }
        } else {
            setLoading(true);
            Request({
                url: "/get-item", props: { id: id }, callback: (response) => {
                    setLoading(false);
                    if (response) {
                        setitem(response);
                        Request({
                            url: "/relation-items", props: {
                                category: response.category_id,
                                id: id
                            }, key: "rels"
                        })
                    }
                }
            })


        }

    }

    const addFavorite = () => {
        let newFav = [];
        if (favorites) {
            newFav = [...favorites];
        }
        if (star) {
            newFav = [...newFav].filter((fa) => fa.id !== item.id)
        } else {
            newFav.push(item)
        }
        setStar(!star)
        setData('favorites', newFav, 'data', true)
        if (user) {
            Request({ url: '/toggle-favorite', props: { id: item.id }, callback: () => { } });
        }
    }


    const Share = () => {
        var copyText = window.location.href;
        navigator.clipboard.writeText(copyText);
        toast.success('لینک کپی شد میتوانید آن را برای دوستانتان ارسال کنید')
    }





    return { navigate, tooltipe, setTooltipe, item, Share, Loading, star, addFavorite, show, Showdes, star, headerBackground, user, rels, relsLoad }
}

export const useShowImage = () => {

    const navigate = useNavigate();
    const [images, setimages] = useState([])
    const { state } = useLocation();

    useEffect(() => {
        if (state) {
            if (state.images) {
                setimages(state.images);
            }
        } else {
            navigate(-1)
        }

    }, []);

    return { navigate, images }
}

export const useReportItem = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { user } = useAppContext();
    const { setForm, Request, form } = useMain();
    const items = [
        {
            key: 'disable',
            title: 'آگهی غیر واقعی'
        },
        {
            key: 'notavailable',
            title: 'صاحب آگهی در دسترس نیس'
        },
        {
            key: 'improperphotography',
            title: 'عکاسی نامناسب'
        },
        {
            key: 'impropergrouping',
            title: 'گروه بندی نامناسب'
        }, {
            key: 'notfound',
            title: 'آگهی پیدا نشد'
        }, {
            key: 'sold',
            title: 'محصول فروخته شده / اجاره رفته'
        }, {
            key: 'price',
            title: 'قیمت نادرست'
        }, {
            key: 'tel',
            title: 'شماره تماس نادرست'
        }, {
            key: 'inappropriate',
            title: 'آگهی نامناسب'
        }, {
            key: 'other',
            title: 'دیگر'
        },
    ];
    useEffect(() => {
        if (location) {
            if (location.state) {
                setForm('item_id', location.state.id)
            }
        }
    }, [])

    const send = () => {

        Request({
            url: "/report-item", callback: (response) => {
                if (response) {
                    navigate(-1);
                }
            }
        });
    }

    return { send, setForm, items, form, user }
}


export const useSearch = () => {
    const navigate = useNavigate();
    const [loading, setloading] = useState()
    const { Request, setData } = useMain();
    const [List, setList] = useState([]);
    const [Text, setText] = useState('')
    const onChange = ({ target }) => {
        setText(target.value)

    }

    useEffect(() => {
        search()
    }, [Text])

    useEffect(() => {
        refBody.current.style.overflowY = 'hidden';
        return () => {
            refBody.current.style.overflowY = 'auto';
        }
    }, [])


    const search = () => {
        if (Text !== '') {
            setloading(true)

            Request({
                url: '/search', props: { text: Text }, callback: (res) => {

                    setloading(false)
                    if (res) {
                        setList(res);
                    }
                }
            })

        }
    }

    const onClick = (category) => {
        if (category.id == 'text') {
            setData('category', null, null, true);
            setData('filter', { text: category.text }, 'data', true)
            navigate('/ProductList')
            return;
        } else {
            setData('category', category, null, true);
            setData('filter', { category_id: category.id }, 'data', true)
            navigate('/ProductList', { state: { category: category } })
            return;
        }
    }

    return { onChange, loading, navigate, List, onClick }

}

export const useUserProfile = () => {
    const { data, setForm, loading, Request } = useMain();
    const [load, setload] = useState(false)
    const [preview, setPreview] = useState()
    const { userProducts, userComments } = data;
    const { user, login } = useAppContext();
    const [tab, setTab] = useState("items");
    const [modal, setModal] = useState(false);

    const edit = () => {
        setload(true)
        Request({
            url: "/edit-profile", callback: (response) => {
                setload(false)
                if (response) {
                    login({ ...user, ...response });
                }
            }
        })
    }

    useEffect(() => {
        Request({
            url: "/user-products",
            key: "userProducts",
            loading: "userProducts"
        })
        Request({
            url: "/user-comments",
            key: "userComments",
            loading: "userComments"
        })
    }, [])


    return { user, preview, setPreview, load, loading, userComments, userProducts, tab, edit, setTab, setModal, modal, setForm }
};

export const useMyProducts = () => {
    const { data } = useMain();
    const { userProducts } = data
    const [tab, setTab] = useState("active");
    const [accordion, setAccordion] = useState(false)
    const { Request, setForm, loading } = useMain();
    const ShowAccordion = () => {
        setAccordion(!accordion)
    }
    return { tab, setTab, accordion, setAccordion, ShowAccordion, userProducts }
};


export const useSupport = () => {
    const { Request, data } = useMain();
    const { tickets, info } = data;
    const { user } = useAppContext();
    useEffect(() => {
        if (user) {
            Request({ url: "/supports", key: 'tickets' });
        }
    }, []);


    return { tickets, info }

}

export const useTicket = () => {
    const { state } = useLocation();
    const [ticket, setticket] = useState()
    const { Request, loading, setForm } = useMain();
    const { user } = useAppContext();
    useEffect(() => {

        if (state) {
            if (state.ticket) {
                setticket(state.ticket)
            }
        }
    }, []);

    const onChange = ({ target }) => {
        setForm(target.name, target.value)
    }

    const send = () => {
        Request({
            url: '/message-ticket', loading: "send", props: { id: ticket.id }, callback: (response) => {
                if (response) {
                    setticket(response)
                }
            }
        })
    }

    return { ticket, user, loading, send, onChange }

}


export const useMessageSupport = () => {

    const { Request, loading, setForm } = useMain();
    const onChange = ({ target }) => {
        setForm(target.name, target.value)
    }
    const navigate = useNavigate();
    const send = () => {
        Request({
            url: '/send-ticket', loading: "send", callback: (response) => {
                if (response) {
                    navigate('/Ticket/' + response.id, { state: { ticket: response } })
                }
            }
        })
    }

    return {
        onChange, send, loading
    }
}


export const useStoreList = () => {

    const { Request, data, loading, setForm } = useMain();


    const { stores } = data;

    useEffect(() => {
        Request({ url: "/stores", key: "stores" })
    }, [])
    const [page, setPage] = useState()
    const [category, setCategory] = useState()
    const selectCategory = (prop) => {
        setPage(null);
        if (prop) {
            setCategory(prop);
            setForm('category_id', prop.id);
            Request({ url: "/stores", key: "stores", props: { category_id: prop.id } })
        } else {
            setCategory(null);
            setForm('category_id', null);
            Request({ url: "/stores", key: "stores", props: { category_id: '' } })
        }

    }


    const changeText = ({ target }) => {
        Request({ url: "/stores", key: "stores", props: { text: target.value } })
    }


    return { stores, changeText, loading, page, setPage, category, selectCategory }

}

export const useStore = () => {
    const [tab, setTab] = useState("items")
    const navigate = useNavigate();
    const { id, user_id } = useParams();
    const { Request } = useMain();
    const [store, setStore] = useState()
    const [items, setItems] = useState()
    const [comments, setComments] = useState()

    useEffect(() => {
        if (id) {
            Request({
                url: "/get-store", props: { id: id },
                callback: (response) => {
                    setStore(response);
                }
            })
            Request({
                url: "/store-items", props: { user_id },
                callback: (response) => {
                    setItems(response);
                }
            })
            Request({
                url: "/store-comments", props: { user_id },
                callback: (response) => {
                    setComments(response);
                }
            })
        }
    }, [])


    return { navigate, tab, setTab, items, comments, store };
}


export const useDeleteItem = () => {
    const { Request, setForm, loading } = useMain();
    const { id } = useParams();
    const navigate = useNavigate();
    const Delete = () => {
        Request({ url: "/delete-item", loading: "delete", props: { id: id } });
    }

    const onChange = ({ target }) => {
        setForm(target.name, target.value)
    }

    return { Delete, Request, onChange, navigate, loading }
}


export const useVisit = () => {

    const [item, setItem] = useState(false);
    const { state } = useLocation();
    useEffect(() => {

        if (state) {
            if (state && state.item) {
                setItem(state.item)
            }
        }
    }, [])

    const Share = () => {
        var copyText = window.location.origin + "/item/" + item.id;
        navigator.clipboard.writeText(copyText);
        toast.success('لینک کپی شد میتوانید آن را برای دوستانتان ارسال کنید')
    }


    return { item, Share }
}

export const usePlans = () => {
    const { Request, data, loading } = useMain();
    const navigate = useNavigate();
    const [plan, setPlan] = useState()
    const { id } = useParams();

    let price = 0;
    let tax = 0;
    let total = 0;


    if (plan) {
        if (plan.meta_data) {
            if (plan.meta_data.price) {
                price = parseInt(plan.meta_data.price);
                tax = (parseInt(plan.meta_data.price) * 9) / 100;
                total = parseInt(price) + parseInt(tax);
            }
        }
    }

    useEffect(() => {
        Request({
            url: "/plans",
            key: "plans",

        });

    }, []);


    const { plans } = data

    const select = (p) => {
        setPlan(p)
    }


    const payment = () => {
        if (plan) {
            Request({
                url: '/payment', props: {
                    plan_id: plan.id,
                    item_id: id
                }, callback: (url) => {
                    if (url) {
                        window.location.replace(url)
                    }
                }
            })
        }
    }

    return { plans, plan, select, price, tax, total, loading, navigate, payment }

}



export const useChats = () => {
    const { state, setData } = useMain();
    const { sendMessage, user } = useAppContext();
    const { rooms } = state;
    useEffect(() => {
        setData('rooms', []);
        sendMessage('open')
    }, [])

    return {
        messages: rooms || [],
        user
    };
}


export const useChat = () => {

    const { state, setData, Request } = useMain();
    const { sendMessage, user } = useAppContext();
    const { chats, room, newChat } = state;
    const [modal, setModal] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [Loading, setLoading] = useState(true)
    const [loadSendFile, setLoadSendFile] = useState(false)
    const [id, setId] = useState()
    const [itemId, setItemId] = useState();
    const [txt, setTxt] = useState('')
    const navigate = useNavigate();
    useEffect(() => {
        var url = new URL(window.location.href);
        var idp = url.searchParams.get("id");
        var itd = url.searchParams.get("item");
        if (idp) {
            setId(idp)
        }
        if (itd) {
            setItemId(itd)
        }
    }, []);
    useEffect(() => {

        if (newChat) {
            if (newChat.room_id == id) {
                setData('room', { ...room, chats: [...room.chats, newChat.message] });
                return;
            }
            if (newChat.item_id == itemId) {
                setData('room', { ...room, chats: [...room.chats, newChat.message] });
                return;
            }
        }
    }, [newChat])

    useEffect(() => {
        sendMessage('room', { id: id, item: itemId })
    }, [itemId])
    useEffect(() => {
        sendMessage('room', { id: id, item: itemId })
    }, [id])
    useEffect(() => {
        if (room) {
            setLoading(false);
            if (!showModal) {
                if (room.item) {
                    if (room.item.shop) {
                        setShowModal(true);
                        setModal(true);
                    }
                }
            }
        }
    }, [room])

    const sendFile = ({ target }) => {
        setLoadSendFile(true)
        Request({
            url: '/upload-image',
            props: {
                image: target.files
            },
            callback: (res) => {
                target.value = null;
                setLoadSendFile(false)
                if (res) {
                    let code = Math.random();
                    newMessage(res.url, code, 'file')
                    sendMessage('newmessage', { id: id, item: itemId, message: res.url, code: code, type: 'file' })

                }
            }
        })
    }

    const newMessage = (msg, code, type = 'text') => {

        setData('room', {
            ...room, chats: [...room.chats, {
                code: code,
                chat_sender: user.id,
                chat_message: msg,
                chat_mimetype: type,
                created_at: new Date(),
            }]
        });
        setTxt('');
    }


    const send = (msg) => {
        let code = Math.random();
        newMessage(msg, code)
        sendMessage('newmessage', { id: id, item: itemId, message: msg, code: code })
    }

    const blocked = () => {
        sendMessage('blocked', { id: id })
    }


    const deleted = () => {
        sendMessage('deleted', { id: id });
        navigate('/Messages');
    }

    return { chats, room, txt, setTxt, blocked, deleted, sendFile, user, loadSendFile, Loading, modal, navigate, setModal, send }

}


export const useScore = () => {

    const { setForm, setFormObj, form, Request } = useMain();
    const [loading, setloading] = useState(false);
    const [room, setroom] = useState(false);
    const { state } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        setFormObj({ score: 0, feedback: 0, speed: 0, verify: 0 })
        if (state) {
            if (state.room) {
                setroom(state.room)
            } else {
                navigate('/')
            }
        }
    }, [])

    const onChange = ({ target }) => {
        setForm(target.name, target.value)
    }

    const addRate = (key, value) => {
        setForm(key, value)
    }

    const send = () => {
        if (room.item) {
            setloading(true);
            Request({
                url: "/score-item", props: { id: room.item.id }, callback: (res) => {
                    setloading(false);
                    if (res) {
                        toast.success(res.message)
                        navigate(-1)
                    }
                }
            })
        }
    }

    return { send, room, form, loading, addRate, onChange }
}

export const useComment = () => {

    const [id, setId] = useState()
    const [Loading, setLoading] = useState()
    const { setForm, form, Request } = useMain();
    const onChange = ({ target }) => {
        setForm(target.name, target.value)
    }
    const sendReplay = () => {
        setLoading(true);
        Request({
            url: "/replay-commnet",
            props: {
                id: id
            },
            callback: (res) => {
                setLoading(false)
                window.document.getElementById('closeBB').click()
                if (res) {
                    toast.success('نظر شما با موفقیت ثبت شد بعد از تایید منتشر می شود')
                }
            }
        })
    }

    return { setId, onChange, Loading, form, sendReplay }
}